import React, { useState } from "react";

const FAQs = () => {
  const faqs = [
    {
      question:
        "What information do I need to provide during the E-KYC registration process on the platform?",
      answer:
        "During E-KYC registration, you'll need to provide your full name, Aadhaar number, PAN number, GST number (if applicable), email, mobile number, WhatsApp number, and an alternate contact number and email. This is verified through a secure OTP process before registration is complete.",
    },
    {
      question:
        "As a borrower, what functionalities can I access after logging into the platform?",
      answer:
        "After logging in, you can view your loan account details, receive notices and reminders about your account status, and update your personal information to stay compliant with KYC requirements.",
    },
    {
      question:
        "What are the mediums through which I will receive reminders and notices?",
      answer:
        "You'll receive reminders and notices through multiple channels: WhatsApp, IVR, Email, and SMS, sent to your KYC-verified contact details so you don't miss important updates.",
    },
    {
      question:
        "Is my data secure on the platform?",
      answer:
        "Your data is encrypted during transmission and stored in compliance with applicable data protection regulations, with access controls in place to prevent unauthorized use.",
    },
    {
      question:
        "How can I get help or update my information?",
      answer:
        "For any questions, support, or requests to update your personal information, reach out to us at support@clevdoc.com. If you're requesting a change to your details, please include supporting documents so we can verify and process it.",
    },
    // {
    //   question:
    //     "Can I update or modify my personal information stored on the platform after registration?",
    //   answer:
    //     "Yes, you can indeed request modifications to your personal information by contacting us at support@clevdoc.com. Please ensure to include supporting documents to validate your requested changes, which will help us verify and process your request.",
    // },
  ];

  const [openIndex, setOpenIndex] = useState(null);

  const toggleAnswer = (index) => {
    setOpenIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <>
      <div className="py-3">
        <div className="mb-10 container mx-auto">
          <div className="mb-8">
            <div className="flex justify-center">
              <p className="text-center text-md font-mono">Banking Platform</p>
            </div>
            <h1 className="md:text-3xl text-2xl text-center font-bold ">
              Frequen
              <span className="underline underline-offset-[10px] decoration-2">
                tly Asked Qu
              </span>
              estions
            </h1>
          </div>
          <div className="bg-bgclr9 border shadow-xl md:mx-24 mx-5 py-7">
            <div className="max-w-5xl mx-auto p-4 grid grid-cols-1 md:grid-cols-2 gap-4">
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  className="mb-4 border-b border-bgclr pb-4 mr-5"
                >
                  <div className="flex justify-between items-center">
                    <div className="text-lg font-semibold mb-2">
                      {faq.question}
                    </div>
                    <button
                      onClick={() => toggleAnswer(index)}
                      className="text-txtclr2 font-bold text-2xl focus:outline-none"
                    >
                      {openIndex === index ? "-" : "+"}
                    </button>
                  </div>
                  {openIndex === index && (
                    <div className="text-gray-700 pl-3 text-lg mt-2">
                      {faq.answer}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FAQs;
